import { useState } from "react";
import { Loader2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { buildReportPdf, reportFileName } from "@/lib/pdf";

export function ReportWaButton({ jobId, testid, compact, onSent, className = "" }) {
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      const { data: job } = await api.get(`/jobs/${jobId}`);
      if (!window.confirm(`Inviare il rapporto PDF su WhatsApp a ${job.client?.first_name} ${job.client?.last_name} (${job.client?.phone})?`)) return;
      const fd = new FormData();
      fd.append("file", await buildReportPdf(job), reportFileName(job));
      const { data } = await api.post(`/inbox/report/${jobId}`, fd);
      toast.success(data.mode === "allegato" ? "Rapporto inviato come allegato WhatsApp"
        : "Inviato su WhatsApp con link al PDF (il cliente non scrive da oltre 24 ore)");
      onSent?.();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button size="sm" variant="outline" className={`rounded-full border-[#25D366] text-[#128C7E] ${className}`} onClick={run} disabled={busy}
      data-testid={testid} title="Invia rapporto su WhatsApp">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <MessageCircle className="h-4 w-4" />}{compact ? " WA" : " Invia al cliente su WhatsApp (081 892 9750)"}
    </Button>
  );
}
